import type { SVGProps } from 'react';
const SvgPausePresentation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pause_presentation_svg__a)">
      <path d="M21 19.1H3V5h18v14.1ZM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z" />
      <path d="M9 8h2v8H9V8Zm4 0h2v8h-2V8Z" />
    </g>
    <defs>
      <clipPath id="pause_presentation_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPausePresentation;
